import { useState, useEffect } from 'react';
import { getModelStatuses } from 'services/models/modelList';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { showError } from '../../../../../redux/common/actions';
import { getLocalStorageData } from 'helpers/utils';
import { SHOW_ALL_OPTION } from '../../constants';

export const useModelStatuses = (showAll = true) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [modelStatuses, setModelStatuses] = useState([]);
  const localStorageData = getLocalStorageData("me");
  const { siteAppID } = localStorageData || {};

  useEffect(() => {
    const loadModelStatuses = async () => {
      try {
        const response = await getModelStatuses(siteAppID);
        if (response.status) {
          const fetchedStatuses = response.data;
          const processedStatuses = showAll 
            ? [SHOW_ALL_OPTION, ...fetchedStatuses]
            : fetchedStatuses;
          
          setModelStatuses(processedStatuses);
        }
      } catch (error) {
        dispatch(
          showError(
            error?.response?.data?.detail || t('message.failedToFetchModelStatuses')
          )
        );
      }
    };

    if (siteAppID) {
      loadModelStatuses();
    }
  }, [siteAppID, showAll, dispatch, t]);

  return modelStatuses;
}; 
